function submitProductImpressions() {
  const elements = document.querySelectorAll('input[value^="a-2544^"]');
  const items = [];
  for (const element of elements) {
    const tokens = element.value.split(/\^/g);
    if (tokens.length >= 4) {
      let [_, productCode, description, price, quantity] = tokens;
      let category = "KPUB";
      if (productCode.match(/^WS/)) {
        category = "KPD";
      } else if (productCode.match(/^INV/)) {
        category = "Accounting";
      }
      quantity = parseFloat(quantity) || 1;
      price = parseFloat(price) || 0;
      items.push({
        "id": productCode,
        "name": description,
        "category": category,
        "quantity": quantity,
        "price": price,
      });
    }
  }
  if (items.length) {
    gtag("event", "view_item_list", {
      "items": items,
    });
  }
}

if (window.gtag) {
  submitProductImpressions();
}
